import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { InTransitPage } from "@/modules/repairs/pages/InTransit.page";

export const Route = createFileRoute("/__authed/m/repairs/in-transit")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_screening")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: InTransitPage,
});
